import './sentry.ts';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { CoreProvider, initializeAuth, observeSSO } from '@scmlatam/web-ui';
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/i18n.ts';
import { LicenseInfo } from '@mui/x-license';
import { processOAuthCallback, startOAuthFlow } from './pages/auth/oauth.ts';
import { AuthorizationProvider } from './contexts/AuthorizationContext';
// import "./styles/oauth-signin.css";

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
        console.error('[Service Worker] Error al registrar:', error);
    });
}

// Iniciar flujo OAuth2 PKCE desde una URL directa (/oauth?next=/ruta).
if (window.location.pathname === '/oauth') {
    const oauthParams = new URLSearchParams(window.location.search);
    const next = oauthParams.get('next') || '/';
    const authuser = oauthParams.get('authuser') || undefined;
    await startOAuthFlow(next, authuser);
}

// Procesar callback OAuth2 antes de montar la app para evitar restricciones
// del router interno de web-ui (que redirige /callback a /signin sin auth).
if (window.location.pathname === '/callback') {
    try {
        await processOAuthCallback();
    } catch (err) {
        console.error('[OAuth callback]', err);
        localStorage.removeItem('access_token');
        localStorage.removeItem('authenticated');
        sessionStorage.removeItem('authenticated');
        window.location.replace('/signin');
    }
}

const msalInstance = await initializeAuth();

observeSSO(msalInstance);

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_KEY || '');

createRoot(document.getElementById('root')!).render(
    <I18nextProvider i18n={i18n}>
        <CoreProvider>
            <AuthorizationProvider>
                <App msalInstance={msalInstance} />
            </AuthorizationProvider>
        </CoreProvider>
    </I18nextProvider>,
);
